import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Text, Flex, Button, Divider, Image } from "@chakra-ui/react";

import Topbar from "components/topbar";
import MainLayout from "components/mainLayout";
import { useShipmentForm } from "context/DHLShipmentFormContext";

const PrintLabel = () => {
  const navigate = useNavigate();
  const { shipmentCreatedData } = useShipmentForm();

  const downloadPdf = (base64, filename = "qr-code.pdf") => {
    const linkSource = `data:application/pdf;base64,${base64}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = filename;
    downloadLink.click();
  };

  return (
    <MainLayout>
      <Flex minH={"100%"} h={"100%"} bg={"#f8fbff"} flexDirection={"column"}>
        <Topbar title={"SHIP THROUGH DHL"} />
        <Flex
          flex={1}
          direction={"column"}
          justifyContent={"space-between"}
          bg={"#FFFFFF"}
          margin={4}
          padding={6}
          borderRadius={"16px"}
          gap={6}
        >
          {/* <Box> */}
          <Text
            fontFamily={"PlusJakartaSansSemiBold"}
            fontSize={"24px"}
            lineHeight={"32px"}
            textTransform={"capitalize"}
            color={"#000000"}
          >
            Create Shipment
          </Text>
          <Divider bg={"#8A8F9333"} h={"1px"} />
          <Box>
            <Flex flexDirection={"column"} gap={6}>
              <Box>
                <Text
                  fontFamily={"PlusJakartaSansSemiBold"}
                  fontSize={"16px"}
                  lineHeight={"20px"}
                  textTransform={"capitalize"}
                  color={"#000000"}
                >
                  Print and You’re Done!
                </Text>
                <Flex
                  gap={4}
                  marginTop={2}
                  borderWidth={"1px"}
                  borderColor={"#D9D9D9"}
                  borderStyle={"solid"}
                  padding={4}
                  borderRadius={"6px"}
                  flexDirection={"column"}
                >
                  <Text
                    fontFamily={"PlusJakartaSansMedium"}
                    fontSize={"12px"}
                    lineHeight={"16px"}
                    textTransform={"capitalize"}
                    color={"#000000"}
                  >
                    Bag Label Preview
                  </Text>
                  {shipmentCreatedData?.dropoff?.IMGS?.map((item) => {
                    return (
                      <Image
                        key={item}
                        src={`data:image/png;base64,${item}`}
                        alt="DHL QR Code"
                        objectFit="contain"
                        width={"200px"}
                        height={"333px"}
                        _hover={{
                          cursor: "pointer",
                        }}
                      />
                    );
                  })}
                  {shipmentCreatedData?.pickup?.IMGS?.map((item) => {
                    return (
                      <Image
                        key={item}
                        src={`data:image/png;base64,${item}`}
                        alt="DHL QR Code"
                        objectFit="contain"
                        width={"200px"}
                        height={"333px"}
                        _hover={{
                          cursor: "pointer",
                        }}
                      />
                    );
                  })}
                  <Flex gap={3} alignItems={"center"}>
                    <Button
                      onClick={() => {
                        if (shipmentCreatedData?.dropoff?.QR[0]?.content) {
                          downloadPdf(
                            shipmentCreatedData?.dropoff?.QR[0]?.content
                          );
                        }
                        if (shipmentCreatedData?.pickup?.QR[0]?.content) {
                          downloadPdf(
                            shipmentCreatedData?.pickup?.QR[0]?.content
                          );
                        }
                      }}
                      w={"140px"}
                      py={6}
                      bg={"#1C1C1C"}
                      borderRadius={"12px"}
                      color={"white"}
                      textTransform={"capitalize"}
                      alignSelf={"flex-end"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      fontSize={"12px"}
                      fontFamily={"PlusJakartaSansBold"}
                    >
                      <Image
                        src={require("assets/svgs/download.svg").default}
                        width={"16px"}
                        height={"16px"}
                        pos={"relative"}
                        mr={2}
                        _hover={{
                          cursor: "pointer",
                        }}
                      />
                      Download Label
                    </Button>
                    {/* <Text
                      fontFamily={"PlusJakartaSansSemiBold"}
                      fontSize={"12px"}
                      color={"#000000"}
                      textTransform={"uppercase"}
                    >
                      or
                    </Text>
                    <Button
                      //   onClick={() => onSelectMethodModalOpen()}
                      w={"140px"}
                      py={6}
                      bg={"#1C1C1C"}
                      borderRadius={"12px"}
                      color={"white"}
                      textTransform={"capitalize"}
                      alignSelf={"flex-end"}
                      alignItems={"center"}
                      justifyContent={"center"}
                      fontSize={"12px"}
                      fontFamily={"PlusJakartaSansBold"}
                    >
                      <Image
                        src={require("assets/svgs/printer.svg").default}
                        width={"16px"}
                        height={"16px"}
                        pos={"relative"}
                        mr={2}
                        _hover={{
                          cursor: "pointer",
                        }}
                      />
                      Print Label
                    </Button> */}
                  </Flex>
                </Flex>
              </Box>

              {/* <Box>
                <Text
                  fontFamily={"PlusJakartaSansSemiBold"}
                  fontSize={"16px"}
                  lineHeight={"20px"}
                  textTransform={"capitalize"}
                  color={"#000000"}
                >
                  Your Tracking Number # 1234567890123
                </Text>
                <Flex
                  gap={4}
                  marginTop={2}
                  borderWidth={"1px"}
                  borderColor={"#D9D9D9"}
                  borderStyle={"solid"}
                  padding={4}
                  borderRadius={"6px"}
                  flexDirection={"column"}
                >
                  <Flex gap={2}>
                    <Text
                      fontFamily={"PlusJakartaSansMedium"}
                      fontSize={"12px"}
                      lineHeight={"16px"}
                      textTransform={"capitalize"}
                      color={"#898989"}
                      width={"170px"}
                    >
                      Piece # 1:
                    </Text>
                    <Text
                      fontFamily={"PlusJakartaSansMedium"}
                      fontSize={"12px"}
                      lineHeight={"16px"}
                      color={"#000000"}
                    >
                      JD014600012035491840
                    </Text>
                  </Flex>
                  <Flex gap={2}>
                    <Text
                      fontFamily={"PlusJakartaSansMedium"}
                      fontSize={"12px"}
                      lineHeight={"16px"}
                      textTransform={"capitalize"}
                      color={"#898989"}
                      width={"170px"}
                    >
                      Pickup Confirmation Number:
                    </Text>
                    <Text
                      fontFamily={"PlusJakartaSansMedium"}
                      fontSize={"12px"}
                      lineHeight={"16px"}
                      color={"#000000"}
                    >
                      PRG250425040517
                    </Text>
                  </Flex>
                  <Flex gap={2}>
                    <Text
                      fontFamily={"PlusJakartaSansMedium"}
                      fontSize={"12px"}
                      lineHeight={"16px"}
                      textTransform={"capitalize"}
                      color={"#898989"}
                      width={"170px"}
                    >
                      Country:
                    </Text>
                    <Text
                      fontFamily={"PlusJakartaSansMedium"}
                      fontSize={"12px"}
                      lineHeight={"16px"}
                      color={"#000000"}
                    >
                      United Kingdom
                    </Text>
                  </Flex>
                  <Flex gap={2}>
                    <Text
                      fontFamily={"PlusJakartaSansMedium"}
                      fontSize={"12px"}
                      lineHeight={"16px"}
                      textTransform={"capitalize"}
                      color={"#898989"}
                      width={"170px"}
                    >
                      Pickup Date:
                    </Text>
                    <Text
                      fontFamily={"PlusJakartaSansMedium"}
                      fontSize={"12px"}
                      lineHeight={"16px"}
                      color={"#000000"}
                    >
                      Fri, Apr 25, 2025
                    </Text>
                  </Flex>
                  <Flex gap={2}>
                    <Text
                      fontFamily={"PlusJakartaSansMedium"}
                      fontSize={"12px"}
                      lineHeight={"16px"}
                      textTransform={"capitalize"}
                      color={"#898989"}
                      width={"170px"}
                    >
                      Pickup Time:
                    </Text>
                    <Text
                      fontFamily={"PlusJakartaSansMedium"}
                      fontSize={"12px"}
                      lineHeight={"16px"}
                      color={"#000000"}
                    >
                      Between 9:30 am and 5:00 pm
                    </Text>
                  </Flex>
                </Flex>
              </Box> */}
            </Flex>
          </Box>
          <Flex
            alignSelf={"flex-end"}
            alignItems={"flex-end"}
            justifyContent={"flex-end"}
            flex={1}
            bottom={0}
            w={"100%"}
            gap={2}
            mt={4}
          >
            <Button
              onClick={() => navigate("/send-a-bag")}
              flex={1}
              maxW={"148px"}
              background={"#000000"}
              color={"#FFFFFF"}
              borderRadius={8}
              fontSize={"12px"}
              fontFamily={"PlusJakartaSansMedium"}
              textTransform={"uppercase"}
              // isDisabled={}
              _disabled={{
                bg: "grey.100",
                cursor: "default",
                _hover: {
                  bg: "grey.100",
                  cursor: "default",
                },
              }}
            >
              Close
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </MainLayout>
  );
};

export default PrintLabel;
